<app-page-header
  title="Coin-Staffelung verwalten"
  subtitle="Pflege die Wertentwicklung deiner Coins und aktualisiere Staffelungen für neue Zeiträume."
  icon="trending_up"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-slide-up">
  <div class="tiering-grid">
    <div class="tiering-card apple-card">
      <div class="card-header">
        <div class="apple-icon-visual">
          <mat-icon>calendar_today</mat-icon>
        </div>
        <div>
          <h2 class="apple-heading-4">Wertänderung auswählen</h2>
          <p class="apple-caption">Bestimme den Stichtag und bearbeite Coin-Werte.</p>
        </div>
      </div>

      <mat-form-field appearance="outline" class="apple-field">
        <mat-label>Datum der Wertänderung</mat-label>
        <mat-select (selectionChange)="onCoinTypeChange($event.value)" [value]="selectedCoinTypeId">
          <ng-container *ngIf="coinTypes$ | async as coinTypes">
            <mat-option *ngFor="let coinType of getSortedCoinTypes(coinTypes)" [value]="coinType.id">
              {{ coinType.activeAt | date: 'dd.MM.yyyy' }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <div *ngIf="selectedCoinType" class="coin-value apple-fade-in">
        <div class="coin-info-row">
          <span class="label">Wert pro Coin</span>
          <span class="value">{{ selectedCoinType.value }} €</span>
        </div>
        <div class="coin-info-row">
          <span class="label">Grundbetrag</span>
          <span class="value">{{ selectedCoinType.baseAmount }} Coins / 1000€</span>
        </div>
      </div>

      <div class="tiering-actions">
        <button
          mat-stroked-button
          color="primary"
          class="apple-button apple-button-primary"
          style="font-size: 15px; color: white; flex-grow: 1;"
          (click)="openNewCoinTypeDialog()"
        >
          <mat-icon>add_circle</mat-icon>
          Neuen CoinType anlegen
        </button>
        <button
          mat-stroked-button
          color="accent"
          class="apple-button apple-button-primary"
          style="font-size: 15px; color: white; flex-grow: 1;"
          [disabled]="!selectedCoinType"
          (click)="openEditCoinTypeDialog()"
        >
          <mat-icon>edit</mat-icon>
          CoinType bearbeiten
        </button>
      </div>
    </div>

    <div class="tiering-card apple-card" *ngIf="selectedCoinType">
      <div class="card-header">
        <div class="apple-icon-visual">
          <mat-icon>stacked_line_chart</mat-icon>
        </div>
        <div>
          <h2 class="apple-heading-4">
            Staffelung vom {{ selectedCoinType.activeAt | date: 'dd.MM.yyyy' }}
          </h2>
          <p class="apple-caption">Staffelwerte für Kundenumsatz und Coin-Anzahl.</p>
        </div>
      </div>

      <div class="table-wrapper">
        <table mat-table [dataSource]="selectedCoinType.tiers" class="apple-tier-table">
          <ng-container matColumnDef="breakPoint">
            <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">Staffelung (ab €)</th>
            <td mat-cell *matCellDef="let tier" class="apple-table-cell">{{ tier.breakPoint }} €</td>
          </ng-container>

          <ng-container matColumnDef="bonusAmount">
            <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">Bonuscoins</th>
            <td mat-cell *matCellDef="let tier" class="apple-table-cell">{{ tier.bonusAmount }}</td>
          </ng-container>

          <ng-container matColumnDef="coinGain">
            <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">Coins pro 1000€</th>
            <td mat-cell *matCellDef="let tier" class="apple-table-cell">{{ tier.coinGain }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['breakPoint', 'bonusAmount', 'coinGain']" class="apple-table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: ['breakPoint', 'bonusAmount', 'coinGain']" class="apple-table-row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
